export default __webpack_public_path__ + "static/media/IIIT_Site_Logo.19ff87e5.png";